import { useState } from 'react';
import { ListElementSchema } from '../../schema/pageElements.val';

interface ListElementProps {
  title?: ListElementSchema['title'];
  list: ListElementSchema['list'];
}

const ListElement = ({ title, list }: ListElementProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const nShowItems = isExpanded ? list.length : 28;
  const shownItems = list.slice(0, nShowItems);
  const hasMoreItems = list.length > 28;

  return (
    <div className="w-full laptop:px-128">
      {title && (
        <h3 className="font-respira text-respira-sm tablet:text-respira-md flex-1 max-w-920 block mb-96">
          {title}
        </h3>
      )}

      <div className="grid grid-cols-2 laptop:grid-cols-4 gap-24 gap-y-4">
        {shownItems.map((item, idx) => {
          return (
            <div key={idx} className="leading-relaxed break-keep text-nowrap">
              {item}
            </div>
          );
        })}
      </div>

      {hasMoreItems && (
        <button
          className="cursor-pointer p-12 -m-12"
          onClick={() => setIsExpanded(!isExpanded)}
          aria-label={isExpanded ? 'Show less' : 'Show more'}
        >
          {isExpanded ? '-' : '+'}
        </button>
      )}
    </div>
  );
};

export default ListElement;
